export enum Experiments {
  ManageBadgesButtonInMainTab = 'specs.membersArea.ManageBadgesButton',
  RefreshWidgetsOnSettingsChange = 'specs.membersArea.RefreshWidgetsOnSettingsChange',
  CustomProfile = 'specs.membersArea.customProfile',
}
